import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

export default function ControlPropertyItem(props) {
	const { label, isNotSelected, content } = props;

	return (
		<Wrapper>
			<Title>{label}</Title>
			<Content $isNotSelected={isNotSelected}>{content}</Content>
		</Wrapper>
	);
}


const Wrapper = styled.section`
	padding: var(--px-4) var(--px-8);
	width: 100%;
`;

const Title = styled.label`
	color: var(--neutrals-700);
	margin-bottom: var(--px-4);
	font-size: var(--px-14);
	font-weight: 400;
	line-height: var(--px-20);
`;

const Content = styled.section`
	color: ${({ $isNotSelected }) => ($isNotSelected ? 'var(--red-700)' : 'var(--neutrals-900)')};
	font-size: var(--px-14);
	font-weight: 400;
	line-height: var(--px-20);
`;

ControlPropertyItem.propTypes = {
	label: PropTypes.string.isRequired,
	isNotSelected: PropTypes.bool,
	content: PropTypes.string,
};

ControlPropertyItem.defaultProps = {
	isNotSelected: false
};
